<div class="container-fluid">
  <!--  <app-pagetitle title="Dashboard" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>-->
  <div class="text-left">
    <div>
      <mat-card-title>Business Overview</mat-card-title>
    </div>
    <h3>Referral Code <b>{{loggedInUserData.referCode}}</b></h3>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="row">

        <div class="col-sm-4 col-md-3">
          <app-stat title="Downloads" class="pointer" [routerLink]="['my-earnings']"
                    [queryParams]="{isDownloads:true}"
                    [value]="businessOverViewData?businessOverViewData.totalDownloads:'-'"
                    icon="fa fa-mobile"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3 ">
          <app-stat title="Earnings From Downloads" class="pointer" [routerLink]="['my-earnings']"
                    [queryParams]="{isDownloads:true}"
                    [value]="'₹'+businessOverViewData?.earningsFromDownloads||'-'"
                    icon="icon-megaphone"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3">
          <app-stat title="OutStanding Balance"
                    [value]="'₹'+businessOverViewData?.outStandingBalance||'-'"
                    icon="icon-report"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3">
          <!--          <app-stat title="Available Balance to Withdraw"-->
          <!--                    [value]="'₹'+businessOverViewData?.openingAccountBalance||'-'"-->
          <!--                    icon="icon-bank-account"></app-stat>-->

          <div class="card border-success">
            <div class="card-body">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <p class="text-truncate font-size-14 mb-2"><b>Available To Withdraw</b></p>
                  <h4
                    class="mb-0">{{ businessOverViewData && businessOverViewData.availableToWithdraw >= 0 ? '₹' + businessOverViewData.availableToWithdraw : '-'}}</h4>
                </div>
                <div class="text-primary">
                  <i class="text-success-lite fas fa-wallet fa-2x"></i>
                  <!--                  <i class="icon-bank-account font-size-24"></i>-->
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-sm-4 col-md-3">
          <app-stat title="Total Referral Sales" class="pointer"
                    [value]="businessOverViewData?.totalReferralSales||'-'"
                    routerLink="my-earnings"
                    [queryParams]="{isCommissions:true}"
                    icon="icon-sales"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3">
          <app-stat title="Earnings From Sales" class="pointer"
                    [value]="'₹'+businessOverViewData?.earningsFromCommission||'-'"
                    routerLink="my-earnings"
                    [queryParams]="{isCommissions:true}"
                    icon="icon-salary"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3">
          <app-stat title="Total Earnings"
                    [value]="'₹'+businessOverViewData?.totalEarnings||'-'"
                    icon="icon-earnings"></app-stat>
        </div>
      </div>

    </div>
  </div>
  <div class="text-left" *ngIf="(userType.toLowerCase() == 'drivingschool')">
    <h3>Students Overview</h3>
  </div>
  <div class="row"  *ngIf="(userType.toLowerCase() == 'drivingschool')">
    <div class="col-12">
      <div class="row">

        <div class="col-sm-4 col-md-3">
          <app-stat title="Total No. of Students" class="pointer" routerLink="/driving-school/students"
                    [value]="dashboardData?dashboardData.totalCustomer:'-'"
                    icon="fa fa-users"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3 ">
          <app-stat title="New Students for month" class="pointer" routerLink="/driving-school/students"
                    [value]="dashboardData?dashboardData.newCustomersForCurrentMonth:'-'"
                    icon="fa fa-users"></app-stat>
        </div>
        <div class="col-sm-4 col-md-3">
          <app-stat title="Total Driving Alerts of Students" class="pointer"
                    routerLink="/driving-school/alert-customers"
                    [queryParams]="{isDrivingAlerts:true}"
                    [value]="dashboardData?dashboardData.totalDrivingAlertsCount:'-'"
                    icon="ri-steering-2-fill"></app-stat>
        </div>
      </div>

    </div>
  </div>
</div>
